import { KeyValueModel } from "model";
import { EnumStatusTransferencia } from "model/enums/enum-status-transferencia";

export const StatusTransferenciaMock: KeyValueModel[] = [
    new KeyValueModel(EnumStatusTransferencia.Pendente, "Pendente"),
    new KeyValueModel(EnumStatusTransferencia.Aceito, "Aceito"),
    new KeyValueModel(EnumStatusTransferencia.Autorizada, "Autorizado"),
    new KeyValueModel(EnumStatusTransferencia.Estornada, 'Estornado'),
    new KeyValueModel(EnumStatusTransferencia.SemRemessa, 'Sem Remessa'),
    new KeyValueModel(EnumStatusTransferencia.Expirada, 'Expirado'),
    new KeyValueModel(EnumStatusTransferencia.Rejeitada, 'Rejeitado'),
    new KeyValueModel(EnumStatusTransferencia.ProcessandoEstorno, 'Processando Estorno'),
    new KeyValueModel(EnumStatusTransferencia.ErroInterno, 'Erro Interno'),
    new KeyValueModel(EnumStatusTransferencia.Abortada, 'Abortado'),
    new KeyValueModel(EnumStatusTransferencia.Todos, "Todos"),
];